import React from "react";

function Spinner() {
  return (
    <div className="spinner">
      <div className="line"></div>
    </div>
  );
}

export default Spinner;
